<template>
    <div id="app">
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>
  import { provideToast } from 'vue-toastification/composition'

  import MainLayout from '@/layouts/MainLayout.vue'
  import { isUserLoggedIn } from '@/auth/utils'

  export default {
    components: {
      'main-layout': MainLayout,
    },
    computed: {
      layout() {
        return `${this.$route.meta.layout || 'main'}-layout`
      },
      isUserLoggedIn () {
        return this.$store.getters.getUserStatus || isUserLoggedIn()
      },
    },
    async created () {
      await this.$store.dispatch('authSettings/fetchAuthSettings')
      await this.$store.dispatch('paymentSettings/fetchPaymentSettings')

      if (this.isUserLoggedIn) {
        const abilities = await this.$store.dispatch('authSettings/fetchPermissions')
        this.$ability.update(abilities)
      }
    },
    setup() {
      provideToast({
        hideProgressBar: true,
        closeOnClick: false,
        closeButton: false,
        icon: false,
        timeout: 3000,
        transition: 'Vue-Toastification__fade',
      })
    },
  }
</script>

<style lang="scss">
    @import "assets/scss/common.scss";
    #app {
        min-height: 100%;
    }
</style>
